import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useSetAtom } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { PostPurchase } from '~teacher/components/PostPurchase';
import { queryClient } from '~teacher/queryClient';

import teacherRouter from '../../../routers/teacher-router';

export function renderPostPurchasePage({ teamId }: { teamId: string }) {
  ReactDOM.render(
    <PostPurchasePage teamId={teamId} />,
    document.getElementById('main-content')
  );
}

/**
 * There can be a delay between when a user completes a purchase and when
 * the subscription from stripe is communicated to socrative. This component adds
 * an artificial delay to make the purchase appearance more seamless.
 */
export function PostPurchasePage({ teamId }: { teamId?: string }) {
  const setSelectedTeamId = useSetAtom(selectedTeamIdAtom);

  if (teamId !== undefined) {
    console.log('setting team id');
    console.log('teamId', teamId);
    setSelectedTeamId(teamId);
    teacherRouter.navigate('post-purchase', { replace: true });
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col align-center justify-center py-80">
        <PostPurchase />
      </div>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
